Fix<template>
  <div class="kpt-groups-root kpt-list-page">
    <vue-headful title="Groups" />
    <header class="kpt-list-header">
      <h4>Groups</h4>
    </header>
    <div class="kpt-list-actions">
      <div class="buttons">
        <b-button v-if="$hasRole('Super User,Kymeta Admin,Product Support,Account Admin')" size="is-small" @click="openGroupCreate" icon-left="plus">
          Create Group
        </b-button>
        <b-button size="is-small" icon-left="sync" @click="getGroups">
          Refresh List
        </b-button>
      </div>
    </div>
    <div class="kpt-list-table">
      <b-table
        :data="groups"
        sticky-header
        :narrowed="true"
        :hoverable="true"
        :loading="isLoading"
        @sort="sortGroups"
        sort-icon="chevron-up"
        sort-icon-size="is-small"
        default-sort="name"
        default-sort-direction="asc"
        ref="groupTable"
        class="has-horizontal-scroll is-full-height">
        <b-table-column field="name" label="Name" v-slot="props" sortable>
          <span v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')">
            <router-link :to="{ name: 'groupOverview', params: { id: props.row.id } }">{{ props.row.name }}</router-link>
          </span>
          <span v-else>
            {{ props.row.name }}
          </span>
        </b-table-column>
        <b-table-column field="entityType" label="Type" v-slot="props" cell-class="is-capitalized" sortable>
          {{ props.row.entityType }}
        </b-table-column>
        <b-table-column field="ownerId" label="Owner" v-slot="props" sortable>
          {{ getAccountName(props.row.ownerId) }}
        </b-table-column>
        <b-table-column field="sharedWith" label="Shared With" v-slot="props" sortable>
          {{ props.row.sharedWith && props.row.sharedWith[0] ? props.row.sharedWith[0].name : '-' }}
        </b-table-column>
        <b-table-column field="entities.length" label="# of Entities" v-slot="props" sortable>
          {{ props.row.entities ? props.row.entities.length : 0 }}
        </b-table-column>
        <template slot="empty">
          <p>No groups were found.</p>
        </template>
      </b-table>
    </div>
    <div class="kpt-list-footer">
      <list-pagination :total="groupsCount" :size="pageSize" :current="currentPage" @change="changePage"></list-pagination>
    </div>
  </div>
</template>
<script>
import ListPagination from '../shared/ListPaginationComponent.vue';
import { exportCsvMixin } from '../shared/mixins/exportCsvMixin';

export default {
  data() {
    return {
      filterTags: [],
      currentPage: 1,
      pageSize: 50,
      sortBy: 'name',
      sortDirection: 'asc',
      hiddenColumns: [],
      visibleColumns: [],
      allColumns: []
    }
  },
  components: {
    ListPagination
  },
  mixins: [exportCsvMixin],
  async mounted() {
    await this.getGroups();
  },
  computed: {
    groups() {
      const { groups } = this.$store.state.groups;
      if (!groups) return [];
      
      // sort the groups
      groups.sort((a, b) => {
        if (a[this.sortBy] < b[this.sortBy]) return this.sortDirection == 'asc' ? -1 : 1;
        if (a[this.sortBy] > b[this.sortBy]) return this.sortDirection == 'asc' ? 1 : -1;
        return 0;
      });

      // filter the groups so the result set matches the page size and current page
      const filteredGroups = groups.filter((g, idx) => {
        const rangeStart = (this.pageSize * this.currentPage) - this.pageSize;
        const rangeEnd = (this.pageSize * this.currentPage) - 1;
        return idx >= rangeStart && idx <= rangeEnd;
      });
      return filteredGroups;
    },
    isLoading() {
      return this.$store.state.groups.isLoadingGroups;
    },
    title() {
      return this.$route.name;
    },
    groupsCount() {
      return this.$store.state.groups.count;
    },
    accounts() {
      return this.$store.state.accounts.accounts.map(a => ({ id: a.id, name: a.name }));
    }
  },
  methods: {
    openGroupCreate() {
      // clear out any pre-selected items when initiating from the list page (here)
      this.$store.commit('assignPreselectedEntity', null);
      // route the user to create group wizard
      this.$router.push({ name: 'groupCreate' });
    },
    sortGroups(field, order) {
      this.sortBy = field;
      this.sortDirection = order;
    },
    changePage(page) {
      this.currentPage = page;
    },
    openTableSettings() {
      this.$store.commit('setContextPane', 'columnEditor');
    },
    async getGroups() {
      await this.$store.dispatch('fetchGroups', {});
    },
    getAccountName(accountId) {
      if (!accountId) return '-';
      const account = this.accounts.find(a => a.id == accountId);
      return account ? account.name : '-';
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setContextPane', null);
    next();
  }
}
</script>
<style lang="scss" scoped>
.kpt-groups-root {
  position: relative;
  height: 100%;

  ::v-deep .loading-overlay {
    z-index: 9;
  }
}
</style>
